// src/Components/announcements/AnnouncementDetailViewMode.js
import React from "react";
import { fmtDateTime } from "../../Utils/dates";
import styles from "../../Styles/Announcementnew2.module.css";

function AnnouncementDetailViewMode({ safeDraft, isCompactView }) {
  return (
    <>
      <div
        className={`${styles.metaRow} ${
          isCompactView ? styles.metaRowCompact : ""
        }`}
      >
        <div className={styles.metaItem}>
          <div className={styles.metaLabel}>Luotu</div>
          <div className={styles.metaValue}>
            {fmtDateTime(safeDraft.createdAt)}
          </div>
        </div>

        <div className={styles.metaItem}>
          <div className={styles.metaLabel}>Päivitetty</div>
          <div className={styles.metaValue}>
            {fmtDateTime(safeDraft.updatedAt)}
          </div>
        </div>
      </div>

      <div className={styles.sectionBlock}>
        <h3 className={styles.sectionTitle}>Kuvaus</h3>
        <div
          className={styles.viewBox}
          style={{
            minHeight: isCompactView ? 160 : 230,
            maxHeight: isCompactView ? "none" : 420,
            overflow: isCompactView ? "visible" : "auto",
          }}
        >
          {(safeDraft.content || "").split("\n").map((line, i) => (
            <p key={i} style={{ margin: "0 0 10px 0" }}>
              {line}
            </p>
          ))}
        </div>
      </div>

      <div className={styles.sectionBlock}>
        <h3 className={styles.sectionTitle}>Dokumentit</h3>
        <div className={styles.viewBox}>
          {(safeDraft.attachments || []).length === 0 && (
            <div className={styles.mutedSmall}>Ei liitteitä</div>
          )}

          {(safeDraft.attachments || []).map((a) => (
            <div key={a.id || a.url} className={styles.docRow}>
              <span className={styles.docName}>{a.name || "Liite"}</span>
              <button
                className={styles.docOpenBtn}
                onClick={() => window.open(a.url || "#", "_blank")}
              >
                Avaa
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default AnnouncementDetailViewMode;